import { downloadFile } from "@/utils/download";
import { client } from "./client";

export const downloadInvoice = async (furnitureCodesCounts: Record<string, number>) => {
    const response = await client.post("api/invoice/print", furnitureCodesCounts, {
        responseType: "blob",
    });

    if (response.headers["content-type"] === "application/pdf" && response.data instanceof Blob) {
        const contentDisposition = response.headers["content-disposition"];
        const filename = contentDisposition?.split("filename=")[1]?.split(";")[0];

        downloadFile(response.data, filename ?? "invoice.pdf");
    }
};
